import { gql } from '@apollo/client';

export const ATTACH_PAYMENT_METHOD = gql`
  mutation attachPaymentMethod($paymentMethodId: String!) {
    attachPaymentMethod(paymentMethodId: $paymentMethodId)
  }
`;
